import { render } from "./emoji_input.vue?vue&type=template&id=2d6a5654"
import script from "./emoji_input.js?vue&type=script&lang=js&external"
export * from "./emoji_input.js?vue&type=script&lang=js&external"

import "./emoji_input.vue?vue&type=style&index=0&id=2d6a5654&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__